import React from "react";
import Nav from "react-bootstrap/Nav";
import { useHistory } from "react-router";
import { NavDropdown } from "react-bootstrap";

export default function SixWheelMenu() {
  const history = useHistory();

  return (
    <>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("SixWheelScan");
          }}
        >
          scan
        </Nav.Link>
      </Nav.Item>
    </>
  );
}
